
import NavBar from "./components/NavBar";
import Watcher from "./components/Watcher";

export default {
  data() {
    return {
      sidebar: false,
      user: "usuario",
    };
  },
  computed: {
    isNavBarEnabled() {
      return this.$route.path === "/login" ? false : true;
    },
  },
  components: {
    NavBar,
    Watcher,
  },
};
